/** App link for an entity reference (jobs, notifications, steps). */
export function entityHref(entity: string | null | undefined, id: number | null | undefined): string | null {
  if (!entity || id == null) return null;
  switch (entity) {
    case "song":
      return `/songs/${id}`;
    case "video":
      return `/watch/${id}`;
    case "clip":
      return `/clips/${id}`;
    case "render":
      return `/renders/${id}`;
    case "job":
      return `/jobs?job=${id}`;
    case "post":
      return `/calendar?post=${id}`;
    default:
      return null;
  }
}

export function entityLabel(entity: string | null | undefined, id: number | null | undefined): string {
  if (!entity) return "";
  return id == null ? entity : `${entity} #${id}`;
}
